import { jsx as _jsx } from "react/jsx-runtime";
import { extendBlockerContentStylesheet } from "@devowl-wp/web-cookie-banner";
import { useBlockerStylesheet } from "../../../hooks/blocker/useBlockerStylesheet.js";
import { useCommonFooterLinks } from "../../../hooks/common/useFooterLinks.js";
const BlockerFooter = ()=>{
    const { FooterContainer } = useBlockerStylesheet().extend(...extendBlockerContentStylesheet);
    const { rows: links, render: renderLinks } = useCommonFooterLinks({
        putPoweredByLinkInRow: 1
    });
    return /*#__PURE__*/ _jsx(FooterContainer, {
        children: /*#__PURE__*/ _jsx("div", {
            children: renderLinks(links)
        })
    });
};
export { BlockerFooter };
